import { type EventMessage, EventType } from '@azure/msal-browser';
import { onMsalMessage } from '@precon-tools-suite-by-shared/vue-msal';
import type { Router } from 'vue-router';

export function setupErrorPages(router: Router) {
    router.addRoute({
        name: 'auth-login-failure',
        path: '/auth/login-failed',
        component: () => import('../pages/LoginFailed.vue'),
        meta: {
            layout: 'access-denied',
        },
        props: true,
    });

    onMsalMessage((message: EventMessage) => {
        switch (message.eventType) {
            case EventType.LOGIN_FAILURE:
                router.push({ name: 'auth-login-failure' });
                break;
        }
    });
}
